import { inject, Injectable } from '@angular/core';
import { showRequestErrors } from '@softline/application';
import { RequestError, Store } from '@softline/core';
import {
  MessageBarStore,
  modalFn,
  SOFTLINE_FEATURE_MESSAGE_BAR,
} from '@softline/ui-core';
import { RecordTimestampDialogComponent } from '../components/dialogs/record-timestamp-dialog/record-timestamp-dialog.component';
import { Timestamp } from '../data/timestamp.model';
import { SOFTLINE_FEATURE_TIMESTAMP, TimestampStore } from '../stempelerfassung.shared';

@Injectable({ providedIn: 'root' })
export class StempelerfassungQuickCreateService {
  private readonly store = inject(Store);
  private readonly modal = modalFn();

  async recordTimestamp(): Promise<void> {
    const result = await this.modal({
      component: RecordTimestampDialogComponent,
      title: 'Stempel erfassen',
      subtitle: 'Stempelart und Uhrzeit auswählen',
      icon: 'fa-regular fa-clock',
    });

    if (result === 'DISMISSED') return;

    try {
      await this.store.dispatch(SOFTLINE_FEATURE_TIMESTAMP, TimestampStore.actions.create, {
        entity: result as Timestamp,
      });
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.success,
        {
          title: '#TIMESTAMP.MESSAGES.ADD_SUCCESS.TITLE',
          message: '#TIMESTAMP.MESSAGES.ADD_SUCCESS.MESSAGE',
        }
      );
    } catch (e) {
      if (e instanceof RequestError) {
        await this.store.dispatch(
          SOFTLINE_FEATURE_MESSAGE_BAR,
          MessageBarStore.actions.error,
          {
            title: '#TIMESTAMP.MESSAGES.ADD_FAILURE.TITLE',
            message: e.message,
          }
        );
      } else {
        showRequestErrors(this.store, e);
      }
    }
  }
}
